import PropTypes from 'prop-types'
import classNames from 'classnames'

import { ReactComponent as BillingXCircle } from '../../../assets/images/common/icons/billing-x-circle.svg'
import { ReactComponent as BillingCheckCircle } from '../../../assets/images/common/icons/billing-check-circle.svg'
import { ReactComponent as BillingRefundCircle } from '../../../assets/images/common/icons/billing-refund-circle.svg'
import { ReactComponent as BillingPendingCircle } from '../../../assets/images/common/icons/stripe-pending-icon.svg'

import classes from './BillingStatusBadge.module.scss'

const STATUS_ICON = {
  outstanding: BillingXCircle,
  invoiced: BillingPendingCircle,
  paid: BillingCheckCircle,
  offlinePayment: BillingCheckCircle,
  refunded: BillingRefundCircle,
  none: BillingXCircle,
}

// Single source of truth for the billing status badge so the Enrollments & Billing list and the
// drawer's Billing tab can't drift apart. `display` is the { label, variant } pair returned by
// formatInvoiceStatusDisplay / formatPaymentStatusDisplay.
const BillingStatusBadge = ({ display, className }) => {
  const Icon = STATUS_ICON[display?.variant]

  return (
    <span className={classNames(classes.badge, classes[`status_${display?.variant}`], className)}>
      {Icon && <Icon className={classes.icon} width={19} height={19} />}
      {display?.label}
    </span>
  )
}

BillingStatusBadge.propTypes = {
  display: PropTypes.shape({
    label: PropTypes.string,
    variant: PropTypes.string,
  }),
  className: PropTypes.string,
}

export default BillingStatusBadge
